import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { throttle, debounce } from "throttle-debounce";
import MultiselectTable from "./MultiselectTable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { USER } from "../../_constants/actionConstants";
import userActions from "../../_actions/userActions";
import employeeActions from "../../_actions/employeeActions";

class EmployeeMultiselect extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchString: "",
      currPage: 1,
      pageCount: 1,
    };

    this.columns = [
      {
        path: "fullName",
        label: "Name",
        isSortable: false,
        content: (emp) => (
          <span>
            {emp.fullName}
            {emp.userId && (
              <FontAwesomeIcon icon="user-circle" className="fa-fw ml-1 text-secondary" />
            )}
          </span>
        ),
      },
      {
        path: "employeeNo",
        label: "S#",
        content: (emp) => <small>{emp.employeeNo}</small>,
        isSortable: false,
      },
    ];

    this.autocompleteThrottled = throttle(250, this.autocompleteSearch);
    this.autocompleteDebounced = debounce(250, this.autocompleteSearch);
  }

  async componentDidMount() {
    const { dispatch, tabId } = this.props;
    // Fetch data. Units are used for determining loan status.
    const pageCount = await dispatch(
      employeeActions.getAll(tabId, this.state.currPage, 50)
    );
    this.setState({ pageCount });
  }

  componentDidUpdate(prevProps, prevState) {
    const { nameFilter: currNameFilter } = this.props;
    const { nameFilter: prevNameFilter } = prevProps;
    if ((currNameFilter || "") !== (prevNameFilter || ""))
      this.setState({ searchString: currNameFilter }, this.filterChangeCallback);
  }

  autocompleteSearch = (s) => {
    const { dispatch, tabId } = this.props;
    dispatch({ type: USER.SET_EMPLOYEE_SEARCH_WAITINGFOR, waitingFor: s, tabId });
    dispatch(employeeActions.getSuggestions(tabId, s));
    this.setState({ pageCount: 1 });
  };

  /**
   * Callback after filter has been updated (whether internally thru handleChange_search
   * or externally thru props.nameFilter).
   */
  filterChangeCallback = async () => {
    const { searchString: s } = this.state;
    const { dispatch, tabId } = this.props;
    this.setState({ currPage: 1 });
    let pageCount = 1;
    if (!s) pageCount = await dispatch(employeeActions.getAll(tabId, 1, 50, true));
    else if (s.length < 5) this.autocompleteThrottled(s);
    else this.autocompleteDebounced(s);
    this.setState({ currPage: 1, pageCount });
  };

  getNextPage = () =>
    this.setState({ currPage: this.state.currPage + 1 }, () =>
      this.props.dispatch(
        employeeActions.getAll(this.props.tabId, this.state.currPage, 100)
      )
    );

  handleChange_search = (e) =>
    this.setState({ searchString: e.target.value }, this.filterChangeCallback);

  getDisabledItems = () => {
    const {
      employeeList,
      disabledItems: disabledItemsFromProps,
      disableProDMSUsers,
    } = this.props;
    let disabledEmployeeIds = (disabledItemsFromProps || []).map((e) => e.employeeId);
    disabledEmployeeIds = [
      ...disabledEmployeeIds,
      ...(disableProDMSUsers
        ? (employeeList || [])
            .filter((e) => e.isRegisteredInProDMS)
            .map((e) => e.employeeId)
        : []),
    ];
    const disabledItemIds = Array.from(new Set(disabledEmployeeIds));
    const disabledItems = (employeeList || []).filter((e) =>
      disabledItemIds.includes(e.employeeId)
    );
    return disabledItems;
  };

  render() {
    const { searchString, currPage, pageCount } = this.state;
    const { handleSelect, handleDeselect, selectedItems, deletedItems, employeeList } =
      this.props;
    return (
      <>
        <div className="form-inline mb-2">
          <div className="input-group w-100">
            <div className="input-group-prepend">
              <span className="input-group-text bg-lightgray">
                <FontAwesomeIcon icon="search" className="fa-fw text-muted" />
              </span>
            </div>
            <input
              name="searchString"
              id="searchString"
              className="form-control"
              value={searchString}
              onChange={this.handleChange_search}
              placeholder="Search by name or S#"
            />
          </div>
        </div>
        <div className="flex-grow-1 border table-staff-list">
          <MultiselectTable
            className="table table-sm table-hover"
            data={employeeList || []}
            selectedItems={selectedItems || []}
            deletedItems={deletedItems || []}
            disabledItems={this.getDisabledItems()}
            columns={this.columns}
            idPropName={"employeeId"}
            onSelect={handleSelect}
            onDeselect={handleDeselect}
            disableAllSort={true}
            isPaginated={true}
            currPage={currPage}
            pageCount={pageCount}
            getNextPage={this.getNextPage}
          />
        </div>
      </>
    );
  }
}

EmployeeMultiselect.propTypes = {
  handleSelect: PropTypes.func,
  handleDeselect: PropTypes.func,
  selectedItems: PropTypes.array,
  deletedItems: PropTypes.array,
  disabledItems: PropTypes.array,
  disableProDMSUsers: PropTypes.bool,
  tabId: PropTypes.number,
};

const mapStateToProps = (state, ownProps) => ({
  employeeList: state.users.openEmployeeLists[ownProps.tabId] || null,
});

export default connect(mapStateToProps)(EmployeeMultiselect);
